<template>
  <q-card flat :style="$q.screen.lt.md?'':'min-width: 500px'">
    <q-card-section class="no-padding">
      <q-banner class="bg-blue text-white" inline-actions>
        <span>نوع چاپ را انتخاب کنید</span>
        <template v-slot:action>
          <q-btn icon="close" flat round v-close-popup/>
        </template>
      </q-banner>
    </q-card-section>
    <q-card-section class="no-padding">
      <q-select v-model="selectedPrintForm"
                :options="printList"
                option-value="id"
                option-label="Caption"
                filled
                label="نوع گزارش خود را انتخاب کنید"
      />
    </q-card-section>
    <q-card-actions align="left">
      <q-btn label="تایید" @click="loadReport" icon="done" color="primary"/>
      <q-btn label="انصراف" v-close-popup icon="cancel" color="red" flat class="q-ml-sm"/>
    </q-card-actions>
  </q-card>
</template>

<script>
export default {
  name: 'EstelamPrintDialog',
  components: {},
  props: {
    title: {
      type: String,
      default: () => 'گزارش'
    },
    factorInfo: {
      type: Object,
      default: () => {
      }
    },
    goodsNameType:{
      type: String,
      default: ()=> undefined
    }
  },
  data() {
    return {
      selectedPrintForm: undefined,
      printList: [
        {id: 1, Caption: 'چاپ استعلام به همراه تعداد', CountVisible: true},
        {id: 2, Caption: 'چاپ استعلام بدون تعداد', CountVisible: false}
      ]
    }
  },
  methods: {
    async loadReport() {
      if (this.selectedPrintForm) {
        await this.openURL(`https://report.norl.ir/Reports/report/ECAPPV2/گزارشات خرید/فرم استعلام خرید?rs:Format=PDF&Buy_Num=${this.factorInfo.Buy_Num}&Buy_Kind=${this.factorInfo.Buy_Kind}&CountVisible=${this.selectedPrintForm.CountVisible}&GoodsNameType=${this.goodsNameType}&rc:Parameters=False&rc:Zoom=Page%20Width`)
      } else {
        this.$q.notify(
            {
              type: 'negative',
              color: 'negative',
              position: 'top',
              message: 'نوع گزارش را انتخاب نمایید'
            })
      }
    }
  }
}
</script>